import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";

export type Inputs = "modo" | "observaciones" | "idMembresiaActualizacion";
export type Buttons = "aceptar" | "cancelar";

export const gestionFormConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "modo",
      label: "Modalidad",
      bts: { mCol: 12 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Establecida por el sistema",
        data: [
          { value: "ALCANCE", label: "Solo alcance" },
          { value: "DESCARTADA", label: "Descartada" }
        ]
      }
    },
    {
      name: "observaciones",
      label: "Observaciones",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {
        rows: 4
      }
    },
    {
      name: "idMembresiaActualizacion",
      label: "Tipo de membresía",
      bts: { mCol: 12 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Tipo original",
        data: [
          { value: -1, label: "Token promocional" },
          { value: 5013, label: "Membresía Bronce" },
          { value: 5014, label: "Membresía Plata" },
          { value: 5015, label: "Membresía Oro" },
          { value: 5016, label: "Membresía Diamante" }
        ]
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Guardar",
      isSubmit: true,
      bts: { mCol: 6 },
      component: IButtonBuilder
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: { mCol: 6 },
      component: IButtonBuilder
    }
  ],
  validations: {},
  rows: [
    ["modo"],
    ["idMembresiaActualizacion"],
    ["observaciones"],
    ["aceptar", "cancelar"]
  ]
};
